document.addEventListener("teeinblue-event-component-injected", (e) => {
  ymq_option.make_items_hook = (items) => {
    const instance = ymq_option.productInstance;
    instance.config.ignore_main_product = true;
    return [
      {
        id: instance.variant.variant_id,
        quantity: instance.getQuantity(),
        properties: Array.from(
          document.querySelectorAll('#tee-hidden-input input[type="hidden"]')
        ).reduce(
          (acc, i) => {
            const propertyName = i.getAttribute("name");
            const names = propertyName.match(/properties\[(.*)\]/);
            if (Array.isArray(names) && names.length > 1) {
              const name = names[1];
              return {
                ...acc,
                [name]: i.value,
              };
            }
            return acc;
          },
          { ...(instance.ajax_properties ?? {}) }
        ),
      },
    ];
  };
});
